import { combineReducers, configureStore } from "@reduxjs/toolkit";

import filtersReducer from "./slices/filtersSlice";
import itemListsReducer from "./slices/itemListsSlice";
import userReducer from "./slices/userSlice";

const rootReducer = combineReducers({
  user: userReducer,
  itemLists: itemListsReducer,
  filters: filtersReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const makeStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer: rootReducer,
    preloadedState,
    devTools: process.env.NODE_ENV !== "production",
  });

export type AppStore = ReturnType<typeof makeStore>;
export type AppDispatch = AppStore["dispatch"];

export * from "./hooks";
export * from "./slices/filtersSlice";
export * from "./slices/itemListsSlice";
export * from "./slices/userSlice";
export * from "./useStore";
